import React, { useRef } from 'react';
import classnames from 'classnames';
import SliderPagination from '../../components/slider/sliderPagination';

import useIntersectionObserverInitializer from '../../hooks/useIntersectionObserverInitializer';
import OfferSlide from './offerSlide';
import { initLegacySlider } from '../../components/slider/imageSlider';
import { ShCurrency, ShShootingType } from '@shoootin/config';
import { ShOfferDTO, ShOfferScanDTO } from '@shoootin/api';

export const SliderScanOfferWrapper = ({
  offer,
  currency,
  shootingType,
}: {
  offer: ShOfferScanDTO;
  currency: ShCurrency;
  shootingType: ShShootingType;
}) => {
  const sliderRef = useRef<HTMLDivElement>(null);

  const initializer = useIntersectionObserverInitializer({
    callback: () => {
      initLegacySlider(sliderRef.current!);
      console.debug('initLegacySlider');
    },
  });

  return (
    <>
      {initializer.marker}
      <div
        className={classnames('slider', 'offer-slider inline')}
        ref={sliderRef}
      >
        <div className="swiper-container">
          <div
            className="swiper-wrapper"
            css={{
              display: 'flex',
            }}
          >
            {offer &&
              offer.scan.priceRanges.map((range, i) => (
                <OfferSlide
                  offer={offer}
                  currency={currency}
                  key={i}
                  index={i}
                  shootingType={shootingType}
                />
              ))}
          </div>
        </div>
        <SliderPagination count={offer.scan.priceRanges.length} />
      </div>
    </>
  );
};
const SliderOfferWrapper = ({
  offers,
  currency,
  shootingType,
}: {
  offers: ShOfferDTO[];
  currency: ShCurrency;
  shootingType: ShShootingType;
}) => {
  const sliderRef = useRef<HTMLDivElement>(null);

  const initializer = useIntersectionObserverInitializer({
    callback: () => {
      initLegacySlider(sliderRef.current!);
      console.debug('initLegacySlider');
    },
  });

  return (
    <>
      {initializer.marker}
      <div
        className={classnames('slider', 'offer-slider inline')}
        ref={sliderRef}
      >
        <div className="swiper-container">
          <div
            className="swiper-wrapper"
            css={{
              display: 'flex',
            }}
          >
            {offers &&
              offers.map((offer, i) => (
                <OfferSlide
                  offer={offer}
                  currency={currency}
                  key={i}
                  index={i}
                  shootingType={shootingType}
                />
              ))}
          </div>
        </div>
        <SliderPagination count={offers.length} />
      </div>
    </>
  );
};

export default SliderOfferWrapper;
